import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    pastExams: {
      backgroundColor: "#fff",
      borderRadius: 3,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)"
    },
    header: {
      display: "flex",
      alignItems: "center",
      height: 47,
      fontSize: 16,
      padding: "0 20px 0 16px",
      borderBottom: `1px solid ${primary.light}`
    },
    mobileHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 46,
      color: primary.dark,
      marginTop: -10
    },
    mobileTitle: {
      fontSize: 16,
      color: "#595a5a"
    },
    carousel: {
      "& .BrainhubCarouselItem": {
        display: "block",
        "& .MuiPaper-root": {
          height: "auto"
        }
      }
    },
    mobileExamHistoryItem: {
      "&:first-child": {
        marginBottom: 0
      }
    },
    comment: {
      borderLeft: "none",
      borderRight: "none",
      "& div": {
        fontSize: 14
      },
      "& > div": {
        padding: "11px 20px 11px 16px"
      }
    },
    footer: {
      marginTop: -10
    },
    noExams: {
      height: 580,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textTransform: "capitalize",
      color: primary.light,
      "&.mobileView": {
        height: 100,
        backgroundColor: "#fff"
      }
    }
  };
});
